module.exports = __webpack_public_path__ + "media/video-thumbnails/4-b899ea16.gif";